// extracted by mini-css-extract-plugin
module.exports = {"feed":"tumblr_feed__1Xjz3","post":"tumblr_post__1aMtA","text":"tumblr_text__3Yo8F"};